import {
  type ConsentManager,
  PERMISSION_VALUE,
  ResolvedPermissionValue,
} from '@vgtv/consent-manager';

import { resolveWithTimeout } from '../../utils/async';

const DEFAULT_TIMEOUT_IN_MILLISECONDS = 2500;

export const getAdPermission = async (consentManager?: ConsentManager) => {
  if (!consentManager) {
    return PERMISSION_VALUE.ACCEPTED;
  }

  return resolveWithTimeout({
    promise: consentManager.getPermissionAsync('CMP:advertising'),
    fallback: PERMISSION_VALUE.DENIED,
    timeout: DEFAULT_TIMEOUT_IN_MILLISECONDS,
  });
};

export const getAdConsentKeywords = (cmpConsent: ResolvedPermissionValue) => {
  return {
    'kw_aa-sch-cmp_advertising': cmpConsent,
    'cmp_advertising': cmpConsent,
  };
};
